// extracted by mini-css-extract-plugin
module.exports = {"defiContainer":"styles_defiContainer__mssU3","searchInputIcon":"styles_searchInputIcon__odg2V"};